/**
 * CARO logotype, "Evolución" (2026-09-28): custom geometric letters in a fine
 * stroke; the C and the O are the same circle, the C an O that is opening.
 * Masters (SVG + PNG, negro / marfil / blanco, with descriptor, icon) live in
 * `../docs/brand/logo-evolucion/`; this is the same geometry drawn inline with
 * `currentColor`, so it takes the ink of wherever it sits (dark header, ivory
 * footer) without extra files or requests.
 *
 * The A and R legs are cut flat at the baseline (y = 100) by the nested <svg>
 * viewport, like the masters' clipPath, but without an id that would collide
 * when several logos render at once (header, menu, footer, poster).
 *
 * The parts carry classes (`wm-c`, `wm-ar`, `wm-o`) so the folded header can
 * morph CARO → C. in CSS alone (global.css, "Brand morph"): A and R fade, the O
 * travels into the C's opening and shrinks into the brown dot of the icon.
 * `xMinYMid slice` keeps the letters anchored left at full height while the
 * element narrows to the icon's width.
 */
export function CaroWordmark({ className, title = 'CARO' }: { className?: string; title?: string }) {
  return (
    <svg
      className={className}
      viewBox="-2 -2 440 104"
      preserveAspectRatio="xMinYMid slice"
      role="img"
      aria-label={title}
      fill="none"
      stroke="currentColor"
      strokeWidth={7.5}
    >
      <path className="wm-c" d="M88.96 18.99A48.25 48.25 0 1 0 88.96 81.01" />
      <svg className="wm-ar" x={-2} y={-2} width={440} height={102} viewBox="-2 -2 440 102" overflow="hidden">
        <path strokeLinejoin="miter" strokeMiterlimit={8} d="M114.06 112L162.37 5.82L210.69 112" />
        <path d="M133.17 70H191.58" />
        <path strokeLinejoin="miter" d="M239.12 100V3.75H259.12A25.13 25.13 0 0 1 259.12 54H239.12" />
        <path d="M257.12 54L317.78 112" />
      </svg>
      <circle className="wm-o" cx={385.37} cy={50} r={48.25} />
    </svg>
  );
}
